import { createSlice } from '@reduxjs/toolkit';
import i18n from '../../i18n/i18n';
import { IOrganizationAdmin } from '../../interface/organization-admin.interface';
import {
  createOrganizationAdmin,
  getOrganizationAdmins,
} from '../action/organization-admin.action';

interface OrganizationAdminState {
  allAdmins: IOrganizationAdmin[];
  isAdminLoading: boolean;
  pagination?: { total: number };
  error?: string | null;
  isAdminCreating: boolean;
}

const initialState: OrganizationAdminState = {
  allAdmins: [],
  isAdminLoading: false,
  pagination: { total: 0 },
  error: null,
  isAdminCreating: false,
};

const organizationAdminSlice = createSlice({
  name: 'organizationAdmin',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOrganizationAdmins.pending, (state) => {
        state.isAdminLoading = true;
        state.error = null;
      })
      .addCase(getOrganizationAdmins.fulfilled, (state, action) => {
        state.isAdminLoading = false;
        state.allAdmins = action.payload.data.admin || [];
        state.pagination = {
          total: action.payload.data.total || 0,
        };
      })
      .addCase(getOrganizationAdmins.rejected, (state, action) => {
        state.isAdminLoading = false;
        state.error = action.error.message || i18n.t('toast.failed_to_fetch_admins', 'Failed to fetch admins');
      })

      // Create Guardian
      .addCase(createOrganizationAdmin.pending, (state) => {
        state.isAdminCreating = true;
      })
      .addCase(createOrganizationAdmin.fulfilled, (state) => {
        state.isAdminCreating = false;
      })
      .addCase(createOrganizationAdmin.rejected, (state) => {
        state.isAdminCreating = false;
      });
  },
});

export default organizationAdminSlice.reducer;
